module.exports = __webpack_public_path__ + "img/recycleorder.155b1ef0.png";